export default "__VITE_ASSET__LCsYc5h9__"